export default __webpack_public_path__ + "static/media/i31.01ef2fb7.jpeg";